module.exports = __webpack_public_path__ + "img/broker-banner.9a798a9f.webp";